module.exports = __webpack_public_path__ + "static/assets/b526c1fdbbcf5e07a2ed065d5bcb7a15.svg";